import React from 'react';
import { Mail, MapPin, Phone } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const Contatti = () => {
  const contactInfo = [
    {
      icon: Mail,
      title: 'Email',
      value: 'fabio@alfaequity.ch',
      link: 'mailto:fabio@alfaequity.ch'
    },
    {
      icon: Phone,
      title: 'Telefono',
      value: '+41 79 789 66 92',
      link: 'tel:+41797896692'
    },
    {
      icon: MapPin,
      title: 'Sede',
      value: 'Gentilino, Collina d\'Oro',
      value2: 'Svizzera'
    }
  ];

  return (
    <section id="contatti" className="py-24 bg-gray-50">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block bg-blue-100 text-blue-900 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Contattaci
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Parliamo del vostro progetto
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            Siamo qui per rispondere alle vostre domande e capire insieme le opportunità 
            per la vostra azienda.
          </p>
        </div>

        {/* Contact Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {contactInfo.map((info, index) => {
            const Icon = info.icon;
            return (
              <Card key={index} className="border-2 border-gray-200 hover:border-blue-900 transition-all duration-300 hover:shadow-xl">
                <CardContent className="p-8 text-center">
                  <div className="bg-blue-900 w-16 h-16 rounded-lg flex items-center justify-center mx-auto mb-6">
                    <Icon className="text-white" size={28} />
                  </div>
                  <h3 className="font-bold text-gray-900 mb-4 text-xl">{info.title}</h3>
                  {info.link ? (
                    <a 
                      href={info.link} 
                      className="text-blue-900 hover:underline font-medium text-lg"
                    >
                      {info.value}
                    </a>
                  ) : (
                    <>
                      <p className="text-gray-600 text-lg">{info.value}</p>
                      {info.value2 && <p className="text-gray-600 text-lg">{info.value2}</p>}
                    </>
                  )}
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center max-w-3xl mx-auto">
          <div className="bg-blue-900 rounded-2xl p-12">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Pronti a iniziare?
            </h3>
            <p className="text-xl text-gray-200 mb-8">
              Contattateci per una valutazione preliminare della vostra attività.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="mailto:fabio@alfaequity.ch"
                className="inline-flex items-center justify-center bg-white text-blue-900 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-all duration-300 hover:shadow-xl"
              >
                <Mail size={20} className="mr-2" />
                Invia email
              </a>
              <a
                href="tel:+41797896692"
                className="inline-flex items-center justify-center bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-blue-900 transition-all duration-300"
              >
                <Phone size={20} className="mr-2" />
                Chiama ora
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contatti;